//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';


@Component({
    selector: 'app-edit-headers-lib-ccp',
    templateUrl: './edit-headers-lib-ccp.component.html',
    styleUrls: ['./edit-headers-lib-ccp.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/HeaderGlobal.css'],
    standalone: false
})
export class EditHeadersLibCCPComponent implements OnInit {

  //-========================= SECTION VARIABLES =========================-\\

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR GENERAL COMPONENT ==================+\\
  public CCP_Headers: Headers_CCP[] = [];

  constructor(private Service_CCP: LIBRARYCCPService) { }

  ngOnInit(): void {
    this.Load_Component_Header();
  }


  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  private async Load_Component_Header(): Promise<void> {


    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const ResGetHeaders: any = await firstValueFrom(this.Service_CCP.GetHeadersEdit());

      if (ResGetHeaders.success) {

        this.CCP_Headers = ResGetHeaders.operation;

        Loader.classList.remove('active');
      }

    } catch (e) {
      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Notifique este error al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });

      Loader.classList.remove('active');
    }
  }

  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\


  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR DROP ITEM ==================-\\
  public drop(event: CdkDragDrop<any[]>): void {
    moveItemInArray(this.CCP_Headers, event.previousIndex, event.currentIndex);
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\


  //&===================== FUNCTIONS FOR SAVE CHANGES IN HEADERS =====================&\\

  //-================== FUNCTTION FOR SAVED HEADERS ==================-\\
  public SaveHeaders(): void {

    Swal.fire({
      title: '¿Desea guardar los cambios de las cabeceras de CCP?',
      text: "¡Modificara el orden y los nombres en caso de que haya hecho cambios!",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '<i class="fa-solid fa-check-double"></i> Sí, guardar',
      cancelButtonText: 'No, Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {

        try {

          for (let i = 0; i < this.CCP_Headers.length; i++) {
            const Header = this.CCP_Headers[i];
            Header.Position = i;
          }

          const ResUpdate: any = await firstValueFrom(this.Service_CCP.EditHeaders({ headers: this.CCP_Headers }));


          if (ResUpdate.success) {
            Swal.fire({
              icon: 'success',
              title: 'Cabeceras modificadas correctamente ',
              confirmButtonColor: this.ColorConfirm
            })
          } else {
            throw "";
          }


        } catch (e) {
          Swal.fire({
            title: 'Ocurrió un error',
            text: '¡Ocurrió un error al actualizar una cabecera, si el problema persiste notifique a supervisor!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          })
        }

        this.Load_Component_Header();

      }
    })

  }

  //&===================== END FUNCTIONS FOR SAVE CHANGES IN HEADERS =====================&\\

}
